/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { badgeListSchema } from "./badgeListSchema.ts";

export const badgesRetrievePathOrgUnitIdSchema = z.uuid();

export const badgesRetrieveStatus200Schema = badgeListSchema;

export const badgesRetrieveResponseSchema = badgesRetrieveStatus200Schema;
